// @flow

import React from 'react';
import { Cookies, withCookies } from 'react-cookie';
import * as Sentry from '@sentry/browser';
import { withErrorHandler } from '@westfieldcorp/coreoz-error-handler';
import { Redirect, Route, Switch } from 'react-router-dom';
import { WORLD_BASE, WORLD_MAP } from '../../path/worldPaths';
import WorldBase from './WorldBase';
import { AREA_BASE } from '../../path/areaPath';
import AreaBase from './AreaBase';
import { MALL_BASE } from '../../path/mallPath';
import MallBase from './MallBase';
import { OFFICE_BASE } from '../../path/officePath';
import { STORE_BASE } from '../../path/storePath';
import StoreBase from './StoreBase';
import ErrorPage from '../../components/ErrorPage';
import {
  cookieDefaultDate,
  defaultCurrency,
  defaultSurfaceUnit,
  twCurrency,
  twSurfaceUnit,
} from '../../const';
import configurationApi from '../../network/api/configurationApi';

type Props = {
  cookies: Cookies
};
type State = {};

let eventId = null;

const onError = (error, info) => {
  Sentry.withScope((scope) => {
    scope.setExtras(info);
    const eventIdLocal = Sentry.captureException(error);
    eventId = eventIdLocal;
  });
};

class MainContent extends React.Component<Props, State> {
  componentDidMount() {
    if (!this.props.cookies.get(twCurrency) || !this.props.cookies.get(twSurfaceUnit)) {
      const path = '/';
      const expires = cookieDefaultDate;
      configurationApi
        .fetchIpConfig()
        .then(response => response.json())
        .then((responseJson) => {
          let currency = defaultCurrency;
          let surfaceUnit = defaultSurfaceUnit;
          if (responseJson.country_code_iso3 === 'FRA') {
            currency = 'EUR';
            surfaceUnit = 'm';
          } else if (responseJson.country_code_iso3 === 'USA') {
            currency = 'USD';
            surfaceUnit = 'ft';
          } else if (responseJson.country_code_iso3 === 'GBR') {
            currency = 'GBP';
            surfaceUnit = 'm';
          }
          this.props.cookies.set(twCurrency, currency, { expires, path });
          this.props.cookies.set(twSurfaceUnit, surfaceUnit, { expires, path });
        })
        .catch(() => {
          this.props.cookies.set(twCurrency, 'EUR', { expires, path });
          this.props.cookies.set(twSurfaceUnit, 'm', { expires, path });
        });
    }
  }

  render() {
    return (
      <Switch>
        <Route path={WORLD_BASE} component={WorldBase} />
        <Route path={AREA_BASE} component={AreaBase} />
        <Route path={MALL_BASE} component={MallBase} />
        <Route path={OFFICE_BASE} component={MallBase} />
        <Route path={STORE_BASE} component={StoreBase} />
        <Route path="*" render={() => <Redirect to={WORLD_MAP} />} />
      </Switch>
    );
  }
}

export default withCookies(withErrorHandler(
  MainContent,
  (<ErrorPage eventId={eventId} />),
  onError,
));
